

import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseDialog from '@/components/dialogs/BaseDialog.vue';
import InputButton from '@/components/input/InputButton.vue';

@Component({
    components: {
        InputButton,
        BaseDialog,
    },
})
export default class OfflineActionDialog extends Vue {

    @Prop({ default: '?' })
    private action!: string;

}
